export default "__VITE_ASSET__PxsMIY3y__"